import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import AuctionCard from '../components/AuctionCard';
import Loader from '../components/Loader';

interface Auction {
  id: string;
  title: string;
  currentPrice: number;
  currency: string;
  images: string[];
  endsAt: string;
  bidsCount: number;
  user: {
    firstName: string;
    rating: number;
  };
}

export default function Auctions() {
  const [auctions, setAuctions] = useState<Auction[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState<'active' | 'ending'>('active');

  useEffect(() => {
    loadAuctions();
  }, [filter]);

  const loadAuctions = async () => {
    setIsLoading(true);
    try {
      const params: any = { status: 'active' };
      if (filter === 'ending') params.endingSoon = true;
      
      const response = await apiService.getAuctions(params);
      setAuctions(response.data.data || []);
    } catch (error) {
      console.error('Error loading auctions:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">🕑 Аукционы</h1>
      </div>

      {/* Filters */}
      <div className="flex gap-2">
        <button
          onClick={() => setFilter('active')}
          className={`px-4 py-2 rounded-full text-sm ${
            filter === 'active'
              ? 'bg-tg-theme-button text-tg-theme-button-text'
              : 'bg-tg-theme-secondary-bg'
          }`}
        >
          🔥 Активные
        </button>
        <button
          onClick={() => setFilter('ending')}
          className={`px-4 py-2 rounded-full text-sm ${
            filter === 'ending'
              ? 'bg-tg-theme-button text-tg-theme-button-text'
              : 'bg-tg-theme-secondary-bg'
          }`}
        >
          ⏰ Скоро завершатся
        </button>
      </div>

      {/* Auctions Grid */}
      {isLoading ? (
        <Loader className="py-8" />
      ) : auctions.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-4xl mb-2">🔨</p>
          <p className="text-tg-theme-hint">Активных аукционов нет</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {auctions.map((auction) => (
            <AuctionCard key={auction.id} {...auction} />
          ))}
        </div>
      )}
    </div>
  );
}
